import React from "react";
import { NavLink } from "react-router-dom";
import { cn } from "../../lib/utils";
import {
  LayoutDashboard,
  FileText,
  Calendar,
  Users,
  Menu,
  Search,
} from "lucide-react";

const MobileNav = ({ onSearchClick, onMenuClick }) => {
  const navItems = [
    {
      label: "Home",
      icon: LayoutDashboard,
      href: "/dashboard",
      show: true,
    },
    {
      label: "Quotes",
      icon: FileText,
      href: "/quotes",
      show: true,
    },
    {
      label: "Search",
      icon: Search,
      onClick: onSearchClick,
      show: true,
    },
    {
      label: "Calendar",
      icon: Calendar,
      href: "/calendar",
      show: true,
    },
    {
      label: "More",
      icon: Menu,
      onClick: onMenuClick,
      show: true,
    },
  ];

  return (
    <nav className="fixed bottom-14 left-0 right-0 z-[9999] bg-background border-t border-b md:hidden safe-area-bottom shadow-lg rounded-t-lg">
      <div className="flex items-center justify-around h-16 pb-safe">
        {navItems
          .filter((item) => item.show)
          .map((item) =>
            item.onClick ? (
              <button
                key={item.label}
                onClick={item.onClick}
                className="flex flex-col items-center justify-center flex-1 h-full text-muted-foreground hover:text-primary transition-colors"
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              >
                <item.icon className="h-5 w-5" />
                <span className="text-xs mt-1">{item.label}</span>
              </button>
            ) : (
              <NavLink
                key={item.label}
                to={item.href}
                className={({ isActive }) =>
                  cn(
                    "flex flex-col items-center justify-center flex-1 h-full transition-colors",
                    isActive
                      ? "text-primary"
                      : "text-muted-foreground hover:text-primary"
                  )
                }
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              >
                <item.icon className="h-5 w-5" />
                <span className="text-xs mt-1">{item.label}</span>
              </NavLink>
            )
          )}
      </div>
    </nav>
  );
};

export default MobileNav;
